import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { REGEX } from 'utils/constants';
import { TaskSampleId } from '../types';

interface SampleCreationParams {
  project: string;
  task: string;
  clientPm: string;
  countries: string[];
  deviceTarget: string;
  emailSubject: string;
  host: string;
}

export const taskSampleProjectMutations = getMutations({
  createSampleProject: {
    action: async (payload: SampleCreationParams): Promise<{ sampleId: string }> => {
      return executeApiCall({
        path: '/projects/tasks/sample-project',

        method: 'post',

        payload,
      });
    },

    validate: ({ clientPm }: SampleCreationParams) => {
      return {
        ok: REGEX.EMAIL.test(clientPm),
        message: 'Client PM must be an email',
      };
    },
  },

  addLegacySampleIdToTask: {
    action: async (payload: {
      owId: string;
      task: string;
      project: string;
    }): Promise<TaskSampleId[]> => {
      return executeApiCall({
        path: '/projects/tasks/sample-ids',

        method: 'post',

        payload,
      });
    },

    parseError: ({ message }) => {
      if (message.includes('id combination provided could be validated'))
        return (t) => ({
          title: t('referenced-ids-do-not-exist'),
          description: t('we-could-not-find-a-match-for-the-ids-provided')!,
        });

      return (t) => ({
        title: t('error-while-saving'),
        description: t('try-again-in-a-few-moments')!,
      });
    },

    messages: {
      success: (t) => ({
        title: t('sample-data-saved'),
        description: t('task-is-now-free-to-be-marked-as-completed-when-the-time-comes')!,
      }),
    },
  },
});
